import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance with interceptors
export const apiClient = axios.create({});

// Store logout callback to be called on 401
let logoutCallback = null;

// Set the logout callback (called from AppShell)
export const setLogoutHandler = (callback) => {
  logoutCallback = callback;
};

// Response interceptor to handle 401 errors (expired/invalid tokens)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      
      // Call logout callback if set
      if (logoutCallback) {
        logoutCallback();
      }
      
      // Show notification
      toast.error("Your session has expired. Please log in again.");
      
      // Redirect to login by reloading (AppShell will show AuthPage)
      window.location.href = "/";
    }
    
    return Promise.reject(error);
  }
);

// Analytics API methods
export const exportLeadsCsv = async (params, token) => {
  const queryParams = new URLSearchParams();
  if (params.segment) queryParams.append("segment", params.segment);
  if (params.status) queryParams.append("status", params.status);
  if (params.leadmaker) queryParams.append("leadmaker", params.leadmaker);
  if (params.product_id) queryParams.append("product_id", params.product_id);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);

  const response = await apiClient.get(
    `${API}/analytics/leads/export?${queryParams.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }
  );

  // Trigger download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `leads_${new Date().toISOString().split('T')[0].replace(/-/g, '')}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const exportSalesSummaryCsv = async (params, token) => {
  const queryParams = new URLSearchParams();
  if (params.segment) queryParams.append("segment", params.segment);
  if (params.status) queryParams.append("status", params.status);
  if (params.leadmaker) queryParams.append("leadmaker", params.leadmaker);
  if (params.product_id) queryParams.append("product_id", params.product_id);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);

  const response = await apiClient.get(
    `${API}/analytics/sales-summary/export?${queryParams.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }
  );

  // Trigger download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `sales_summary_${new Date().toISOString().split('T')[0].replace(/-/g, '')}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getProductSalesSummary = async (params, token) => {
  const queryParams = new URLSearchParams();
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);

  const response = await apiClient.get(
    `${API}/products/sales/summary?${queryParams.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
};

